import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  box-sizing: content-box;\n  z-index: 3;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  cursor: pointer;\n  top: 50%;\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  cursor: pointer;\n  top: 50%;\n  line-height: 1px;\n\n  ",
        ";\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n      ",
        "\n\n      ",
        " {\n        ",
        "\n      }\n\n      ",
        " {\n        ",
        "\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  line-height: 0;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useKeyPress, Button } from "@miro-site/core";
import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import SearchDropdown from "./components/SearchDropdown";
var Wrapper = styled.div.withConfig({
    componentId: "sc-f011a389-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        paddingTop: 7,
        height: 40,
        paddingBottom: 7,
        paddingLeft: 0,
        paddingRight: 0
    });
});
var Input = styled.input.withConfig({
    componentId: "sc-f011a389-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, isFocused = param.isFocused;
    return theme.normalizeStyles({
        color: "primaryIndigo",
        border: "none",
        outline: "none",
        width: [
            isFocused ? "100%" : 44,
            "100%",
            "100%",
            "100%"
        ],
        background: isFocused ? "none" : [
            "none",
            "#F5F5F7",
            "#F5F5F7",
            "#F5F5F7"
        ],
        fontSize: [
            isFocused ? 16 : 0,
            16,
            16,
            16
        ],
        paddingLeft: [
            isFocused ? 36 : 0,
            46,
            46,
            46
        ],
        paddingRight: [
            isFocused ? 36 : 0,
            46,
            46,
            46
        ],
        height: 40,
        borderRadius: 100
    });
});
export var SearchWrapper = styled.div.withConfig({
    componentId: "sc-f011a389-2"
})(_templateObject2(), function(props) {
    if (props.isFocused) {
        return props.theme.normalizeStyles({
            borderRadius: 16,
            left: 0,
            right: 0,
            top: 0,
            boxShadow: "0px 8px 44px rgba(5, 0, 56, 0.16)",
            background: "#FFFFFF"
        });
    } else {
        return props.theme.normalizeStyles({
            left: 0,
            right: 0,
            paddingLeft: 0,
            paddingRight: 0
        });
    }
});
var SvgSearchIcon = styled.svg.withConfig({
    componentId: "sc-f011a389-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        width: 24,
        height: 24,
        marginTop: -12
    });
});
var SvgCloseIconWrapper = styled(Button).withConfig({
    componentId: "sc-f011a389-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        width: 24,
        height: 24,
        marginTop: -12
    });
}, function(param) {
    var theme = param.theme;
    return theme.normalizeStyles(_object_spread({}, theme.focus.outlines.withOffset));
});
var SearchInputWrapper = styled.div.withConfig({
    componentId: "sc-f011a389-5"
})(_templateObject6(), function(param) {
    var theme = param.theme, isFocused = param.isFocused;
    return css(_templateObject5(), isFocused && theme.normalizeStyles({
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: [
            10,
            34,
            34,
            34
        ],
        paddingRight: [
            10,
            34,
            34,
            34
        ]
    }), SvgSearchIcon, theme.normalizeStyles({
        left: isFocused ? [
            10,
            34,
            34,
            34
        ] : 10,
        zIndex: isFocused ? 1 : [
            -1,
            1,
            1,
            1
        ]
    }), SvgCloseIconWrapper, theme.normalizeStyles({
        right: isFocused ? [
            10,
            34,
            34,
            34
        ] : 10
    }));
});
var Search = function(props) {
    var wrapperRef = useRef(null);
    var inputRef = useRef(null);
    var isEscapePressed = useKeyPress("Escape");
    var ref = useState(false), isFocused = ref[0], setFocused = ref[1];
    var ref1 = useState(""), value = ref1[0], setValue = ref1[1];
    var ref2 = useState(0), selected = ref2[0], setSelected = ref2[1];
    var handleClick = function(e) {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            setFocused(false);
        }
    };
    useEffect(function() {
        if (props.onFocusChanged) {
            props.onFocusChanged(isFocused);
        }
        if (isFocused) {
            document.addEventListener("click", handleClick, true);
            window.addEventListener("focusin", onFocusDown);
            return function() {
                document.removeEventListener("click", handleClick, true);
                document.removeEventListener("keydown", onFocusDown);
            };
        }
    }, [
        isFocused
    ]);
    var onFocusDown = function onFocusDown() {
        if (wrapperRef.current && !wrapperRef.current.contains(document.activeElement)) {
            setFocused(false);
        }
    };
    useEffect(function() {
        function performSearch() {
            return _performSearch.apply(this, arguments);
        }
        function _performSearch() {
            _performSearch = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                props.onSearch(value)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return _performSearch.apply(this, arguments);
        }
        if (value) {
            performSearch();
        }
    }, [
        value
    ]);
    useEffect(function() {
        if (isFocused && isEscapePressed) {
            setFocused(false);
        }
    }, [
        isEscapePressed
    ]);
    useEffect(function() {
        if (!isFocused && inputRef.current) {
            inputRef.current.blur();
        }
    }, [
        isFocused
    ]);
    useEffect(function() {
        var ref;
        if (!((ref = props.searchResult) === null || ref === void 0 ? void 0 : ref.length)) {
            return;
        }
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        props.searchResult,
        selected
    ]);
    var onKeyDown = function onKeyDown(e) {
        if (e.code === "ArrowUp" && isFocused) {
            // up
            select(selected - 1);
        }
        if (e.code === "ArrowDown" && isFocused) {
            // down
            select(selected + 1);
        }
    };
    var select = function(activeIndex) {
        var ref;
        if (typeof ((ref = props.searchResult) === null || ref === void 0 ? void 0 : ref[activeIndex]) === "undefined") {
            return;
        }
        setSelected(activeIndex);
    };
    var handleKeyDown = function(e) {
        if (e.code === "Enter") {
            setValue("");
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    };
    return /*#__PURE__*/ _jsx(Wrapper, {
        ref: wrapperRef,
        className: props.className,
        children: /*#__PURE__*/ _jsxs(SearchWrapper, {
            isFocused: isFocused,
            children: [
                /*#__PURE__*/ _jsxs(SearchInputWrapper, {
                    isFocused: isFocused,
                    children: [
                        /*#__PURE__*/ _jsxs(SvgSearchIcon, {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            onClick: function() {
                                setFocused(true);
                            },
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "10.2308",
                                    cy: "10.0879",
                                    r: "6.23077",
                                    stroke: "#050038",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M15 15.0002L21 21.0002",
                                    stroke: "#050038",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Input, {
                            ref: inputRef,
                            isFocused: isFocused,
                            onFocus: function() {
                                setFocused(true);
                            },
                            value: value,
                            onChange: function(e) {
                                setValue(e.target.value);
                            },
                            onBlur: function() {
                                if (value.length === 0) setFocused(false);
                            },
                            //for autotest
                            "data-testid": "templates-search-input"
                        }),
                        isFocused && value.length > 0 && /*#__PURE__*/ _jsx(SvgCloseIconWrapper, {
                            onKeyDown: handleKeyDown,
                            children: /*#__PURE__*/ _jsx("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                onClick: function() {
                                    setValue("");
                                    if (inputRef.current) {
                                        inputRef.current.focus();
                                    }
                                },
                                children: /*#__PURE__*/ _jsx("path", {
                                    d: "M10.5858 12L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L12 13.4142L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L13.4142 12L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L12 10.5858L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L10.5858 12Z",
                                    fill: "#050038"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SearchDropdown, {
                    onSelectTemplate: function(template) {
                        setFocused(false);
                        setValue("");
                        if (props.onSelectTemplate) {
                            props.onSelectTemplate(template);
                        }
                    },
                    isSearching: props.isSearching,
                    searchString: value,
                    open: isFocused && value.length > 0,
                    searchResult: props.searchResult,
                    statusMessages: props.statusMessages,
                    activeIndex: selected,
                    onItemHover: function(itemIndexHover) {
                        setSelected(itemIndexHover);
                    }
                })
            ]
        })
    });
};
export default Search;
